// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB82h_DNSI5nscf6jlz3LV6RDwpP11RewE",
  authDomain: "cue-clock-pro.firebaseapp.com",
  databaseURL: "https://cue-clock-pro-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "cue-clock-pro",
  storageBucket: "cue-clock-pro.firebasestorage.app",
  messagingSenderId: "340733203668",
  appId: "1:340733203668:web:a248247f85ee0da303d741"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Set persistence to LOCAL (stays logged in across browser sessions)
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log('Auth persistence set to LOCAL');
  })
  .catch((error) => {
    console.error('Failed to set auth persistence:', error);
  });

// Initialize Realtime Database and get a reference to the service
export const database = getDatabase(app);

// Initialize Cloud Functions
export const functions = getFunctions(app, 'us-central1');

export default app;